<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Partners</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  
    <form [formGroup]="partnerForm">
      <mat-card class="addadmin">
      <label class="inviteuser">Add Partner</label>
      <div class="row">
          <div class="col d-flex justify-content-center">
            <mat-form-field appearance="outline">
                <input matInput placeholder="Name" formControlName="name">
              </mat-form-field>
          </div>
          <div class="col d-flex justify-content-center">
            <mat-form-field appearance="outline">
                <input matInput placeholder="URL" formControlName="url">
              </mat-form-field>
          </div>
          <!-- <div class="col d-flex justify-content-center">
            <mat-form-field appearance="outline">
                <textarea matInput placeholder="Description" formControlName="description"></textarea>
              </mat-form-field>
          </div> -->
          <div class="col d-flex justify-content-center">
            <mat-form-field appearance="outline">
                <mat-label>Partner Category</mat-label>
                <mat-select [(value)]="selected" formControlName="category">
                  <mat-option value="{{category.id}}" *ngFor="let category of categoryList">
                    {{category.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </div>
    
    
    
    
      </div>
      <div class="col d-flex justify-content-center">
        <div style="margin-top: 20px ;">
    
          <span (click)="fileInput.click()" class="material-icons" style="color: #5d2041;">
            cloud_upload
          </span>
          <label (click)="fileInput.click()" class="uploadimagetext">Upload Image</label>
          <br>
          <i matTooltip="For a better resolution, we recommend uploading a square picture">Recommended ratio 16:9</i>
    
          <form >
          <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
            [uploader]="uploader" />
          </form>
          <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
          <div>
            <img class="uploadedimage" [src]="url" *ngIf="url"></div>
    
        </div>
    
    
    
      </div>
      <button (click)="createPartner()" mat-flat-button color="primary">Create</button>
    </mat-card>
    </form>
      
<div >
</div>

<label style="margin-left: 20px;" class="inviteuser">Arrange Partners</label>

<!-- <div *ngFor="let category of x">
  <div>{{category.category_id}}</div>

  <div class="col d-flex justify-content-center">
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let category of x" cdkDrag>
        <div class="col">
          <p>{{category.partners_list[0].name}}</p>
          <p>{{category.partners_list[0].link}}</p>
          <p>{{category.partners_list[0].description}}</p>
          <p>{{category.partners_list[0].image}}</p>
        </div>
          <div class="col">
            <p style=" text-align: left;">{{category.description}}</p>
          </div>
 </div>
  </div>
  </div>
</div> -->

<!-- <div *ngFor="let partner of partnersList; let i = index" class="row">
  <h3><span>{{partner.name}} Partners</span></h3>
  <p style="margin-top: 40px;">{{partner.description}}</p>
  <div *ngFor="let detail of partnersList[i].partners">
  <img style="max-width: 280px;" src="https://images-lebtivity.s3.amazonaws.com/{{detail.image}}">
</div>
</div> -->

<div *ngFor="let el of x; let i = index">
<div class="col d-flex justify-content-center">
  {{el.category_name}}
</div>
<div class="col d-flex justify-content-center">
  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
<div class="example-box" *ngFor="let partner of x[i].partners_list" cdkDrag>
  <p>{{partner.name}}</p>
  <p>{{partner.description}}</p>
  <p>{{partner.link}}</p>
  <!-- <img src="https://images-lebtivity.s3.amazonaws.com/{{partner.image}}"> -->
  <img style="width: 150px;" src="{{'https://events.globalistic.tech/'+ partner.image}}">
  <button mat-mat-raised-button (click)="deletePartner(partner.id)">Delete</button>
  <button mat-mat-raised-button (click)="showCancellation(partner)">Edit</button>
</div>
</div>
</div>
</div>



<div [style.display]="modal ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  
  <div class="modal-dialog">
    <div class="modal-content">
      
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Edit Partner</h4>
        <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
          class="material-icons">highlight_off</i>

      </div>
      <div style="display: inline-block;">
        <form [formGroup]="partnerFormUpdate">
        <div class="modal-body">
          <div class="col d-flex justify-content-center">
            <mat-form-field appearance="outline">
              <mat-label> Name</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>
        </div>
        <div class="col d-flex justify-content-center">
          <mat-form-field appearance="outline">
            <mat-label> URL</mat-label>
            <input matInput formControlName="url">
          </mat-form-field>
        </div>
        <div class="col d-flex justify-content-center">
          <mat-form-field appearance="outline">
              <mat-label>Partner Category</mat-label>
              <mat-select [(value)]="selectedCat" formControlName="category">
                <mat-option value="{{category.id}}" *ngFor="let category of categoryList">
                  {{category.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col d-flex justify-content-center">
          <div>

            <span (click)="fileInput.click()" class="material-icons" style="color: #5d2041; cursor: pointer;">
              cloud_upload
            </span>
            <label (click)="fileInput.click()" class="uploadimagetext">Upload Image*</label>
            <br>
            <i style="cursor: help;" matTooltip="For a better resolution and fit, we recommend uploading a square picture">Recommended ratio 1:1</i>

            <!-- <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" /> -->
            <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
              [uploader]="uploader" />

            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
            <div style="border: 1px solid black;width: 230px; height: 229px;
            ">
              <img class="uploadedimage" [src]="url" *ngIf="url"></div>
              <i>This is a preview of how your image will show on the event card</i>
          </div>
        </div>
      </div>
          <button (click)="update()" class="confirmcancellation">Update</button>
        
<!--       
        <div class="modal-footer">

        </div> -->
      </form>
      </div>
    
    </div>
  </div>

</div>




